import request, { ARTICLE_API, ARTICLE_API2 } from "./request"
function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}
function param(json) {
    if (!json) return ''
    return cleanArray(Object.keys(json).map(key => {
        if (json[key] === undefined) return ''
        return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
    })).join('&')
}
export const getArticle = (params) => {
    return request({
        url: `${ARTICLE_API}/article/list`,
        method: "get",
        params
    })
}
export const getPosterOrArticle = (params) => {
    // params.timestamp = Date.now()
    return request({
        url: `${ARTICLE_API}/article/list?${param(params)}`,
        method: "get",
    })
}
export const getTab = (params) => {
    // params.timestamp = Date.now()
    return request({
        url: ARTICLE_API2 + "?" + param(params),
        method: "get",
        // data: params
    })
}